/**
 * Welcome Gift-With-Purchase (GWP)
 * --------------------------------
 * Visitors of /pages/welcome get a FREE Hylastra® Gold Serum (SKU 4610)
 * automatically added to their cart once the rest of the cart totals $75+.
 *
 * This script is the storefront half of the offer:
 *   - On /pages/welcome it stores a 30-day visit flag (localStorage) and sets
 *     the cart attribute `_pp_welcome_gwp` = "true".
 *   - On every cart change it adds the gift when the qualifying subtotal
 *     (all lines except the gift) reaches $75, and removes it when it drops
 *     below. If the shopper deliberately removes the gift, it stays removed
 *     for the rest of the browser session. For Super Saver Perks members the
 *     subtotal is checked AFTER their 33% member discount (see
 *     effectiveLineCents) so a cart paying under $75 never gets the gift.
 *   - The gift is kept as the LAST cart line (drawer, cart page, and
 *     checkout's order summary all render cart order): Shopify lists the
 *     newest line first, so a plain add would put the free gift above the
 *     items the shopper actually chose. The add is done as a clear + one
 *     multi-item re-add with the gift positioned oldest (see
 *     rebuildCartWithGiftLast), with a sessionStorage snapshot + restore
 *     path so an interrupted rebuild can never lose the cart.
 *
 * The PRICE is enforced server-side by the `welcome-gift-discount` Shopify
 * Function (purity-welcome-gift-app): 100% off qty 1 of the SKU 4610
 * one-time line, only when the cart attribute is set and the rest of the cart
 * is $75+. Without that automatic discount active, this script would add the
 * serum at full price — do not enable one half without the other.
 */
(function () {
  'use strict';

  var CONFIG = {
    welcomePath: '/pages/welcome',
    giftVariantId: 50891308204320, // Hylastra® Gold Serum — SKU 4610
    giftSku: '4610',
    thresholdCents: 7500, // qualifying subtotal (USD cents), excluding the gift line
    cartAttribute: '_pp_welcome_gwp',
    lineProperty: '_pp_welcome_gift',
    flagKey: 'pp_welcome_gwp', // localStorage {v:1, ts}
    flagMaxAgeDays: 30,
    addedKey: 'pp_welcome_gwp_added', // sessionStorage: we added the gift
    dismissedKey: 'pp_welcome_gwp_dismissed', // sessionStorage: shopper removed it
    rebuildKey: 'pp_welcome_gwp_rebuild', // sessionStorage: cart snapshot during gift-last rebuild
    sortKey: 'pp_welcome_gwp_sorted', // sessionStorage: gift-last reorder attempts this session
    // Super Saver Perks members (tags "Perks" / "Loop Active Subscriber") get
    // this fraction off one-time lines via the client's discount function app.
    // Keep in sync with DEFAULT_PERKS_PERCENTAGE in the welcome-gift-discount
    // function AND the percentage configured on the SuperSaverPerks discount.
    perksRate: 0.33
  };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function hasVisitFlag() {
    var raw = storageGet(window.localStorage, CONFIG.flagKey);
    if (!raw) return false;
    try {
      var data = JSON.parse(raw);
      var maxAgeMs = CONFIG.flagMaxAgeDays * 24 * 60 * 60 * 1000;
      return !!data.ts && Date.now() - data.ts < maxAgeMs;
    } catch (e) {
      return false;
    }
  }

  function setVisitFlag() {
    storageSet(window.localStorage, CONFIG.flagKey, JSON.stringify({ v: 1, ts: Date.now() }));
    // A fresh welcome visit re-activates the offer if it was dismissed
    try { window.sessionStorage.removeItem(CONFIG.dismissedKey); } catch (e) { /* noop */ }
  }

  function isWelcomePage() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return path === CONFIG.welcomePath || path.slice(-CONFIG.welcomePath.length) === CONFIG.welcomePath;
  }

  function isGiftLine(item) {
    return String(item.sku || '').trim() === CONFIG.giftSku && !item.selling_plan_allocation;
  }

  // Only the line WE auto-added (carries the marker property). A serum the
  // shopper bought on purpose matches isGiftLine but never this.
  function isOurGiftLine(item) {
    return isGiftLine(item) && !!(item.properties && item.properties[CONFIG.lineProperty] === 'true');
  }

  // Rebuild an /cart/add.js payload for an existing cart line (variant,
  // quantity, properties, selling plan) so the line survives a cart rebuild.
  function toAddPayload(item) {
    var payload = { id: item.id, quantity: item.quantity };
    if (item.properties && Object.keys(item.properties).length) {
      payload.properties = item.properties;
    }
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      payload.selling_plan = item.selling_plan_allocation.selling_plan.id;
    }
    return payload;
  }

  /**
   * What the shopper will actually pay for this line, in cents.
   *
   * Perks/Loop members (flag injected by theme.liquid) get 33% off one-time
   * lines from the client's SuperSaverPerks discount function — but depending
   * on session state that discount may only materialize at checkout, so
   * /cart.js can still show full prices. When the line carries no line-level
   * discount yet, anticipate the 33% ourselves; when it does (Perks already
   * applied in cart, or another line discount), trust final_line_price as-is.
   * The per-line SKU/history exclusions of the Perks function aren't readable
   * from the storefront, so this can only UNDER-estimate the paid amount —
   * worst case the gift isn't auto-added, never wrongly added. The
   * welcome-gift-discount function stays the pricing authority.
   */
  function effectiveLineCents(item) {
    var cents = item.final_line_price;
    var isPerksMember = window.__ppWelcomeGwpPerksMember === true;
    var alreadyDiscounted = (item.line_level_discount_allocations || []).length > 0;
    if (isPerksMember && !item.selling_plan_allocation && !alreadyDiscounted) {
      cents -= Math.round(cents * CONFIG.perksRate);
    }
    return cents;
  }

  function cartRequest(path, payload) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('welcome-gwp: ' + path + ' failed (' + response.status + ')');
      return response.json();
    });
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
      return response.json();
    });
  }

  function refreshThemeCart() {
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  // One multi-item /cart/add.js, retried once, then falling back to adding
  // the items one by one (a multi-add is all-or-nothing, so e.g. one variant
  // going out of stock mid-rebuild would otherwise sink the whole restore).
  function addItemsWithRetry(items) {
    return cartRequest('cart/add.js', { items: items })
      .catch(function () {
        return new Promise(function (resolve) { setTimeout(resolve, 1500); }).then(function () {
          return cartRequest('cart/add.js', { items: items });
        });
      })
      .catch(function () {
        var chain = Promise.resolve();
        items.forEach(function (item) {
          chain = chain
            .then(function () {
              return cartRequest('cart/add.js', { items: [item] }).catch(function (error) {
                console.warn('welcome-gwp: could not restore a line', error);
              });
            })
            .then(function () {
              return new Promise(function (resolve) { setTimeout(resolve, 700); });
            });
        });
        return chain;
      });
  }

  /**
   * Put the gift at the BOTTOM of the cart. Shopify has no reorder API and
   * lists the newest line first, so the only way is a rebuild: clear the cart
   * (attributes survive /cart/clear.js) and re-add everything in one
   * multi-item call. A multi-item add creates lines in REVERSE array order —
   * the FIRST array item becomes the oldest line, i.e. the bottom of the
   * drawer/cart/checkout (verified on this store) — so the payload is
   * [gift, ...other lines reversed]. The payload is snapshotted to
   * sessionStorage before clearing; evaluate() restores it if the re-add
   * never lands (see the empty-cart branch).
   */
  function rebuildCartWithGiftLast(giftPayload) {
    // Re-read the cart at the last moment so the rebuild never works from a
    // stale event snapshot.
    return fetchCart().then(function (cart) {
      var others = (cart.items || []).filter(function (item) { return !isOurGiftLine(item); });
      var payload = [giftPayload];
      for (var i = others.length - 1; i >= 0; i--) payload.push(toAddPayload(others[i]));
      storageSet(window.sessionStorage, CONFIG.rebuildKey, JSON.stringify({ ts: Date.now(), items: payload }));
      return cartRequest('cart/clear.js', {})
        .then(function () { return addItemsWithRetry(payload); })
        .then(function (result) {
          try { window.sessionStorage.removeItem(CONFIG.rebuildKey); } catch (e) { /* noop */ }
          return result;
        });
    });
  }

  // Carts from before the gift-last change (or a failed rebuild) can still
  // have the gift above paid items — sink it once. Capped per session so any
  // surprise in add-order semantics can never loop into cart churn.
  function maybeSinkGift(cart, giftLine) {
    var items = cart.items || [];
    if (items[items.length - 1] === giftLine) return;
    if (!isOurGiftLine(giftLine) || giftLine.quantity !== 1) return;
    var attempts = parseInt(storageGet(window.sessionStorage, CONFIG.sortKey) || '0', 10);
    if (attempts >= 2) return;
    storageSet(window.sessionStorage, CONFIG.sortKey, String(attempts + 1));
    busy = true;
    rebuildCartWithGiftLast(toAddPayload(giftLine))
      .then(function () {
        busy = false;
        refreshThemeCart();
      })
      .catch(function (error) {
        busy = false;
        console.warn(error);
      });
  }

  function ensureAttribute(cart) {
    if ((cart.attributes || {})[CONFIG.cartAttribute] === 'true') {
      return Promise.resolve(cart);
    }
    var attributes = {};
    attributes[CONFIG.cartAttribute] = 'true';
    return cartRequest('cart/update.js', { attributes: attributes });
  }

  function evaluate(cart) {
    if (busy || !hasVisitFlag()) return;

    if (!(cart.items || []).length) {
      // A gift-last rebuild cleared the cart but its re-add never landed
      // (navigation/network/bot-challenge) — restore the snapshot rather
      // than treating this as an emptied cart.
      var snapshot = null;
      try { snapshot = JSON.parse(storageGet(window.sessionStorage, CONFIG.rebuildKey) || 'null'); } catch (e) { snapshot = null; }
      if (snapshot && snapshot.ts && Date.now() - snapshot.ts < 10 * 60 * 1000 && (snapshot.items || []).length) {
        busy = true;
        addItemsWithRetry(snapshot.items)
          .then(function () {
            try { window.sessionStorage.removeItem(CONFIG.rebuildKey); } catch (e) { /* noop */ }
            busy = false;
            refreshThemeCart();
          })
          .catch(function (error) {
            busy = false;
            console.warn(error);
          });
        return;
      }
      // Cart emptied (or order completed): forget the added marker so a new
      // cart in the same session gets the gift again.
      try { window.sessionStorage.removeItem(CONFIG.addedKey); } catch (e) { /* noop */ }
      return;
    }

    var giftLine = null;
    var qualifyingCents = 0;
    (cart.items || []).forEach(function (item) {
      if (!giftLine && isGiftLine(item)) {
        giftLine = item;
      } else {
        qualifyingCents += effectiveLineCents(item);
      }
    });
    var eligible = qualifyingCents >= CONFIG.thresholdCents;

    var added = storageGet(window.sessionStorage, CONFIG.addedKey) === '1';
    var dismissed = storageGet(window.sessionStorage, CONFIG.dismissedKey) === '1';

    if (eligible && !giftLine) {
      if (added && !dismissed) {
        // We added it earlier and it vanished while still eligible → the
        // shopper removed it on purpose. Respect that for this session.
        storageSet(window.sessionStorage, CONFIG.dismissedKey, '1');
        return;
      }
      if (dismissed) return;

      busy = true;
      ensureAttribute(cart)
        .then(function () {
          var properties = {};
          properties[CONFIG.lineProperty] = 'true';
          // Add + sink to the bottom in one rebuild: a plain add would list
          // the free gift ABOVE the items the shopper actually chose.
          return rebuildCartWithGiftLast({ id: CONFIG.giftVariantId, quantity: 1, properties: properties });
        })
        .then(function () {
          storageSet(window.sessionStorage, CONFIG.addedKey, '1');
          busy = false;
          refreshThemeCart();
        })
        .catch(function (error) {
          busy = false;
          console.warn(error);
        });
    } else if (!eligible && giftLine) {
      // Only auto-remove the line we added, and only while it's the single
      // free unit — extra units were the shopper's own (paid) choice.
      var ours = giftLine.properties && giftLine.properties[CONFIG.lineProperty] === 'true';
      if (!ours || giftLine.quantity !== 1) return;

      busy = true;
      cartRequest('cart/change.js', { id: giftLine.key, quantity: 0 })
        .then(function () {
          try { window.sessionStorage.removeItem(CONFIG.addedKey); } catch (e) { /* noop */ }
          busy = false;
          refreshThemeCart();
        })
        .catch(function (error) {
          busy = false;
          console.warn(error);
        });
    } else if (giftLine && !((cart.attributes || {})[CONFIG.cartAttribute] === 'true')) {
      // Self-heal: gift in cart but attribute missing (e.g. cart predates the
      // welcome visit) — without it the discount function won't fire.
      busy = true;
      ensureAttribute(cart)
        .then(function () {
          busy = false;
          refreshThemeCart();
        })
        .catch(function (error) {
          busy = false;
          console.warn(error);
        });
    } else if (giftLine) {
      storageSet(window.sessionStorage, CONFIG.addedKey, '1');
      maybeSinkGift(cart, giftLine);
    }
  }

  var refreshTimer = null;
  function evaluateFromServer() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      fetchCart().then(evaluate).catch(function () { /* offline */ });
    }, 400);
  }

  function init() {
    if (isWelcomePage()) setVisitFlag();
    if (!hasVisitFlag()) return; // never touches the cart for other visitors

    // Impact dispatches cart:change (detail.cart = /cart.js JSON) after its own
    // mutations, and cart:refresh when third parties (Rebuy etc.) change the cart.
    document.addEventListener('cart:change', function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart && cart.items) evaluate(cart);
      else evaluateFromServer();
    });
    document.addEventListener('cart:refresh', evaluateFromServer);

    if (isWelcomePage()) {
      // Persist the flag on the cart right away so the offer survives
      // localStorage loss and shows up in Admin order attributes.
      fetchCart()
        .then(ensureAttribute)
        .then(evaluate)
        .catch(function () { /* offline */ });
    } else {
      evaluateFromServer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
